<template>
  <v-dialog
    v-model="show"
    @click:outside="close"
    class="login-dialog"
    max-width="750px"
  >
    <v-card color="lightPrimary pt-5">
      <v-card-title
        class="text-h5 text-center title-login-dialog primary--text d-flex align-center justify-center"
        >Seja bem-vindo ao ONDIVAN!</v-card-title
      >
      <v-card-text
        class="d-flex flex-column align-center justify-center text-center mt-3 pb-0"
      >
        <p class="gray--text">
          Agendar uma sessão é fácil!! Para isso encontre o profissional que mais se adequa, depois 
          selecione o dia e horário desejado, selecione sua opção de pagamento e logo após finalize o 
          agendamento! Pronto! Você receberá um email 1h antes da sua sessão, com o link para a sala 
          do atendimento e, pontualmente no horário marcado, a sua sala estará disponível.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="close" color="gray" class="ml-auto text-h6">
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalWelcome',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  computed: {
    show: {
      get() {
        return this.isDialogOpen;
      },
      set(value) {
        return value;
      },
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .v-dialog {
  box-shadow: none !important;
}

.title-login-dialog {
  word-break: break-word;
}
</style>